import { authManagementRoutes } from "@routes/authManagement/route";

import type { RouteObject } from "react-router";

export const outsideRoutes: RouteObject[] = [
  ...(authManagementRoutes?.map((item) => item?.route) || []),
];
